import { EmergencyDetails } from "../project-types";

export const assetIncludesAllProperties = (
  emergency: Pick<EmergencyDetails, "assets">
): boolean => {
  return emergency.assets.includes("All properties");
};
